const GRAVITY_WEBSITE_HANDOFF_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const isGravityWebsiteHandoffId = (value = '') => {
  return GRAVITY_WEBSITE_HANDOFF_ID_PATTERN.test(String(value || '').trim());
};

export default isGravityWebsiteHandoffId;
